import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'spaces',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isMultiSelectable:false,
  newButton:false,
  
  getURL:'graphicmanagers/historic',
  removeURL:'graphicmanagers/historic',

  sessionParams: [],

  emptyMessage: "You don't have any space defined under this app.",
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Id of the space.',
    },
     {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the space.',
    },
       {
      attributeName: 'total',
      label: 'Visible contents',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Total visible contents of the space.',
    },
  ],
};
